export const getLogString = ({
  id,
  event,
  initiator = 'Service',
  type = 'event',
}: any): string => {
  return `\n\t*${initiator}*:
  \t\tType: \`${type}\`
  \t\tId: \`${id}\`
  \t\tEvent: \`${!!event ? '\n' + JSON.stringify(event, null, '\t') : event}\``; // Because event to string return [object Object]
};
